export default "__VITE_ASSET__otWJtYuU__"